import React from "react";
import Footer from "../components/Footer/Footer";
import Navbar from "../components/Navbar/Navbar";
import Baki from "../assets/ersoybaki.jpg";
import SoftwareSolutionsSection1 from "../components/SoftwareSolutions/SoftwareSolutionsSection1/SoftwareSolutionsSection1";
import SoftwareSolutionsSection2 from "../components/SoftwareSolutions/SoftwareSolutionsSection2/SoftwareSolutionsSection2";
import SoftwareSolutionsSection4 from "../components/SoftwareSolutions/SoftwareSolutionsSection4/SoftwareSolutionsSection4";
import SoftwareSolutionsSection5 from "../components/SoftwareSolutions/SoftwareSolutionsSection5/SoftwareSolutionsSection5";
import SoftwareSolutionsSection6 from "../components/SoftwareSolutions/SoftwareSolutionsSection6/SoftwareSolutionsSection6";
import SEO from "../components/SEO";
import { useTranslation } from "react-i18next";

const SoftwareSolutions = () => {
  const { t } = useTranslation("global");
  return (
    <>
      <SEO slug="SoftwareSolutions" />
      <Navbar />
      <SoftwareSolutionsSection1 />
      <SoftwareSolutionsSection2 />
      <SoftwareSolutionsSection4 />
      <SoftwareSolutionsSection5
        quote={t("pages.softwareSolutions.quote")}
        author={t("pages.softwareSolutions.author")}
        title={t("pages.softwareSolutions.title")}
        profileImage={Baki}
      />
      <SoftwareSolutionsSection6 />
      <Footer />
    </>
  );
};

export default SoftwareSolutions;
